import { USER_ROLES } from "./constants";
import MODULES from "./module.constant";

export const getDefaultRedirect = (modules) => {
   // if(modules && Array.isArray(modules) && modules.includes(MODULES.USER)){
   //    return '/users'
   // }
   if(modules && Array.isArray(modules) && modules.includes(MODULES.DASHBOARD)){
      return '/patient'
   }

     return '/'
}